import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { slot: "content" }

import { RouterView } from 'vue-router'
import AppLayoutHeader from './AppLayoutHeader/AppLayoutHeader.vue'
import AppLayoutMobileSidebar from './AppLayoutMobileSidebar.vue'
import AppLayoutSidebar from './AppLayoutSidebar.vue'
import CookieConsentBanner from '@/components/CookieConsent/CookieConsentBanner.vue'
import { cookiesService } from '@/services/CookiesService'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLayoutMain',
  setup(__props) {

const mobileSidebarOpened = ref(false)
const hideCookieConsent = cookiesService.didConsent

function openMobileSidebar() {
  mobileSidebarOpened.value = true
}

function closeMobileSidebar() {
  mobileSidebarOpened.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("dsf-page-layout", null, [
      _createVNode(AppLayoutSidebar, {
        slot: "menu",
        class: "dsf-hidden-mobile"
      }),
      _createVNode(AppLayoutMobileSidebar, {
        slot: "menu",
        opened: mobileSidebarOpened.value,
        onClose: closeMobileSidebar,
        class: "dsf-hidden-tablet dsf-hidden-desktop dsf-hidden-desktopXl dsf-hidden-desktopXxl z-[var(--dsf-z-index-layout)]"
      }, null, 8 /* PROPS */, ["opened"]),
      _createVNode(AppLayoutHeader, {
        slot: "navbar",
        class: "header",
        onOnMobileMenuClick: openMobileSidebar
      }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(RouterView), {
          class: "content dsf-theme-default",
          "data-test": "otters-shell-content"
        })
      ])
    ]),
    (!_unref(hideCookieConsent))
      ? (_openBlock(), _createBlock(CookieConsentBanner, { key: 0 }))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})